<template>
        <v-container container--fluid grid-list-lg class="pa-0 pb-6">
            <v-layout v-if="!showData" row wrap class="pa-2 mx-auto full-height">
                <v-flex xs12 class="justify-center text-center mt-12">
                    <span class="font-weight-bold title">Loading Data... <i class="fas fa-circle-notch fa-spin"></i></span>
                </v-flex>
            </v-layout>
            <v-layout v-if="showData" row wrap class="pa-2 mx-auto full-height">
                <v-flex xs12 class="justify-space-between text-left mt-2">
                    <h1 ref="dashboard" class="grey--text lighten-3 mb-2">High Performance Centre</h1>
                </v-flex>
                <v-flex xs4 md4 class="text-center">
                    <v-card
                        ripple
                        text
                        hover
                        :color="'primary theme--dark'"
                        class="py-3"
                        :to="{ name: 'hpcClasses' }"
                    >
                        <v-card-title class="justify-center">
                            <i class="fas fa-person-running icx-card pb-3"></i>
                            <h1 class="text-uppercase title-card ma-0">Classes</h1>
                            <h2 class="text-center font-weight-regular subtitle-1">Choose your class</h2>
                        </v-card-title>
                    </v-card>
                </v-flex>
                <v-flex xs4 md4 class="text-center">
                    <v-card
                        ripple
                        text
                        hover
                        :color="'primary theme--dark'"
                        class="py-3"
                        :to="{ name: 'hpcPlans' }"
                    >
                        <v-card-title class="justify-center">
                            <i class="fas fa-clipboard-list icx-card pb-3"></i>
                            <h1 class="text-uppercase title-card ma-0">Plans</h1>
                            <h2 class="text-center font-weight-regular subtitle-1">Select HPC Membership</h2>
                        </v-card-title>
                    </v-card>
                </v-flex>
                <v-flex xs4 md4 class="text-center">
                    <v-card
                        ripple
                        text
                        hover
                        :color="'primary theme--dark'"
                        class="py-3"
                        :to="{ name: 'hpcSubscription' }"
                    >
                        <v-card-title class="justify-center">
                            <i class="fas fa-wallet icx-card pb-3"></i>
                            <h1 class="text-uppercase title-card ma-0">Subscription</h1>
                            <h2 class="text-center font-weight-regular subtitle-1">View subscription details</h2>
                        </v-card-title>
                    </v-card>
                </v-flex>
                <v-flex xs4 md4 class="text-center">
                    <v-card
                        ripple
                        text
                        hover
                        :color="'primary theme--dark'"
                        class="py-3"
                        :to="{ name: 'hpcOrders' }"
                    >
                        <v-card-title class="justify-center">
                            <i class="fas fa-file-invoice icx-card pb-3"></i>
                            <h1 class="text-uppercase title-card ma-0">Receipts</h1>
                            <h2 class="text-center font-weight-regular subtitle-1">HPC Payments</h2>
                        </v-card-title>
                    </v-card>
                </v-flex>
                <v-flex xs4 md4 class="text-center">
                    <v-card
                        ripple
                        text
                        hover
                        :color="'primary theme--dark'"
                        class="py-3"
                        :to="{ name: 'hpcEnrolled' }"
                    >
                        <v-card-title class="justify-center">
                            <i class="fas fa-bell icx-card pb-3"></i>
                            <h1 class="text-uppercase title-card ma-0">Enrollments</h1>
                            <h2 class="text-center font-weight-regular subtitle-1">Check your class enrollments</h2>
                        </v-card-title>
                    </v-card>
                </v-flex>
                <v-flex xs4 md4 class="text-center">
                    <v-card
                        ripple
                        text
                        hover
                        :color="'primary theme--dark'"
                        class="py-3"
                        :to="{ name: 'hpcProducts' }"
                    >
                        <v-card-title class="justify-center">
                            <i class="fas fa-calendar icx-card pb-3"></i>
                            <h1 class="text-uppercase title-card ma-0">Special Events</h1>
                            <h2 class="text-center font-weight-regular subtitle-1">HPC Events / Products</h2>
                        </v-card-title>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
</template>

<script>
import moment from "moment";

export default {
    data() {
        return {
            hover: "",
        };
    },
    computed: {
        showData() {
            return this.$store.getters["user/userStatus"] == "success";
        },
        user() {
            return this.$store.getters["user/getProfile"];
        },
    },
    watch: {

    },
    methods: {

    },
    beforeCreate() {

    },
    mounted() {
        // let top = this.$refs['dashboard'].offsetTop;
        setTimeout(function() {
            window.scrollTo(0, 0);
        }, 500);
    }
};
</script>

<style lang="scss" scoped>
[v-cloak], .v-cloak {
    display: none;
}
[v-cloak] > *, .v-cloak > * {
    display: none;
}

.full-height .flex {
    display: flex;
}

.full-height .flex > .v-card {
    flex: 1 1 auto;
}

.title-card {
    font-size: 24px !important;
}

::v-deep .v-select__selection.v-select__selection--comma {
    text-transform: capitalize;
}

::v-deep .v-list-item__title {
    text-transform: capitalize;
}

.v-card {
    .icx-card {
        color: #bdbdbd;
        font-size: 42px;
        flex-basis: 100%;
        text-align: center;
    }

    .hh-logo {
        fill: #bdbdbd;
        width: 52px;
    }

    &:hover {
        .icx-card {
            color: #ffffff;
        }

        .hh-logo {
            fill: #ffffff;
        }

        h2.subtitle-1 {
            color: #ffffff;
        }

        h2.subtitle-2 {
            color: #ffffff;
        }
    }
}

.title-card {
    flex-basis: 100%;
    text-align: center;
}

.v-card--hover.primary h1.title-card {
    // font-family: Roboto,sans-serif !important;
    color: #fff !important;
}

@media only screen and (max-width: 767px) {
    .v-card {
        // max-width: 33.33% !important;
        padding: 8px 0 !important;
    }
    .v-card__title {
        padding: 8px !important;
    }
    .v-card__title i.icx-card {
        padding-bottom: 8px !important;
        font-size: 36px !important;
    }
    .v-card__title h1.title-card {
        font-size: 12px !important;
        line-height: 14px !important;
        word-break: break-word;
    }
    .v-card__title h2.subtitle-1 {
        display: none;
    }
    ::v-deep .v-card__title .v-alert {
        margin-top: 8px !important;
        margin-bottom: 0 !important;
    }
    ::v-deep .v-card__title .v-alert .v-alert__wrapper {
        flex-direction: column !important;
    }
    ::v-deep .v-card__title .v-alert .v-alert__wrapper .v-alert__icon.v-icon {
        align-self: center !important;
        margin: 0 !important;
    }
    ::v-deep .v-card__title .v-alert .v-alert__wrapper .v-alert__content {
        font-size: 10px !important;
        letter-spacing: 0px !important;
        line-height: 16px !important;
        word-break: break-word !important;
    }
    i.v-icon.reg-btn {
        margin: 0 !important;
        font-size: 26px !important;
    }
}
</style>
